import { DefaultModelProperty, LabelValue } from '../standard'
import ContentHouse from './content-house-model'
import contentHouseProperties from './contentHouse-properties'
import { ContentHouseProperties } from './contentHouse-property-definitions'

export async function OnEvents(
  eventType: string,
  form: ContentHouse,
  property: ContentHouseProperties,
): Promise<ContentHouse> {
  switch (eventType) {
    case 'change':
      return await change(property, form)

    default:
      break
  }
  return form
}
export function IsDisabled(property: ContentHouseProperties): boolean {
  switch (property) {
    default:
      return false
  }
}
async function change(
  property: ContentHouseProperties,
  value: ContentHouse,
): Promise<ContentHouse> {
  switch (property) {
    default:
      return value
  }
  return value
}
function getModelProperties(): DefaultModelProperty<ContentHouseProperties>[] {
  return contentHouseProperties as DefaultModelProperty<ContentHouseProperties>[]
}
export function GetPageProperties(): DefaultModelProperty<ContentHouseProperties>[] {
  function getPagePropertyPosition(property: string) {
    switch (property) {
      default:
        return 20
    }
  }
  return AssignUIComponent(
    getModelProperties()
      .filter((x: DefaultModelProperty<ContentHouseProperties>) => {
        return getPagePropertyPosition(x.name) !== -1
      })
      .sort((a, b) => {
        return getPagePropertyPosition(a.name) - getPagePropertyPosition(b.name)
      })
      .map((v: DefaultModelProperty<ContentHouseProperties>) => {
        return v
      }),
  )
}

export function DropdownOptions(
  property: ContentHouseProperties,
): LabelValue<any>[] {
  switch (property) {
    default:
      return []
      break
  }
  return []
}
export function IsRequired(property: ContentHouseProperties): boolean {
  switch (property) {
    case ContentHouseProperties.Owner:
      return false
    case ContentHouseProperties.Id:
      return false
    case ContentHouseProperties.Created:
      return false
    case ContentHouseProperties.Updated:
      return false
    case ContentHouseProperties.Deleted:
      return false
    case ContentHouseProperties.Version:
      return false
    case ContentHouseProperties.Members:
      return false
    case ContentHouseProperties.Invitees:
      return false
    case ContentHouseProperties.Admins:
      return false
    case ContentHouseProperties.Writers:
      return false
    case ContentHouseProperties.Config:
      return false
    case ContentHouseProperties.Readers:
      return false
    case ContentHouseProperties.MembershipRequests:
      return false
    case ContentHouseProperties.State:
      return false
    case 'contentHouseProfileImage':
      return false
    default:
      return true
  }
}
export function AssignUIComponent(
  properties: DefaultModelProperty<ContentHouseProperties>[],
): DefaultModelProperty<ContentHouseProperties>[] {
  return properties.map(
    (modelProperty: DefaultModelProperty<ContentHouseProperties>) => {
      switch (modelProperty.name) {
        default:
          switch (modelProperty.name) {
            case ContentHouseProperties.ContentHouseProfileImage:
              modelProperty.type = 'view-content-house-profile-image'

              break
            default:
              break
          }

          break
      }
      return modelProperty
    },
  )
}
export function IsVisible(property: ContentHouseProperties): boolean {
  switch (property) {
    case ContentHouseProperties.Owner:
      return false
    case ContentHouseProperties.Id:
      return false
    case ContentHouseProperties.Created:
      return false
    case ContentHouseProperties.Updated:
      return false
    case ContentHouseProperties.Deleted:
      return false
    case ContentHouseProperties.Version:
      return false
    case ContentHouseProperties.Members:
      return false
    case ContentHouseProperties.Invitees:
      return false
    case ContentHouseProperties.Admins:
      return false
    case ContentHouseProperties.Writers:
      return false
    case ContentHouseProperties.Config:
      return false
    case ContentHouseProperties.Readers:
      return false
    case ContentHouseProperties.MembershipRequests:
      return false
    case ContentHouseProperties.State:
      return false
    default:
      return true
  }
}
